import {ReactElement, useState} from "react";
import DevourTopNavUserData from "./DevourTopNavUserData";
import SignUpToast from "./SignUpToast";
import { isMobile } from "react-device-detect";
import DevourPlayIcon from "@/pngs/devourplay-icon.png";
import OverwolfGameStatusChip from "@/pages/overwolf/components/OverwolfGameStatusChip";
import { useSelector } from "react-redux";
import { IStore } from "@/redux/defaultStore";


interface Props {
    logoUrl?: string;
    text?: string;
}

function DevourTopNav(props: Props): ReactElement {
    const [
        showToast,
        setShowToast,
    ] = useState<boolean>(false);

    const isOnOverwolf = useSelector((store: IStore) => store.metaStore.isOnOverwolf);

    function handleToastDismissal() {
        setShowToast(false);
    }

    return (
        <>
            <SignUpToast
                message='Join DevourPlay and start your GoFriends journey!'
                isOpen={showToast}
                onDismiss={handleToastDismissal}
            />
            <div className="devour-top-nav">
                <div className="devour-top-nav_navbar">
                    {/* Add empty spacer when in Overwolf mode without logo to push user-data right */}
                    {isOnOverwolf && !props.logoUrl && !props.text && <div />}
                    {props.logoUrl && <img
                        className="devour-top-nav_navbar_logo"
                        src={props.logoUrl}
                        alt="GoFrens"
                    />}
                    {props.text && !isOnOverwolf &&
                        <div className="devour-top-nav_navbar_title-section">
                            {isMobile &&
                                <img
                                    className="devour-top-nav_navbar_mobile-icon"
                                    src={DevourPlayIcon}
                                    alt="DevourPlay"
                                />
                            }
                            <h4 className="devour-top-nav_navbar_text">{props.text}</h4>
                        </div>
                    }
                    <DevourTopNavUserData
                        dropdownAnchorElement=".devour-top-nav"
                        onShowSignInToast={() => setShowToast(true)}
                        showGameStatus={isOnOverwolf}
                        gameStatusCompact={isMobile}
                    />
                </div>
            </div>
        </>
    );
}

export default DevourTopNav;
